import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faHome } from '@fortawesome/pro-light-svg-icons/faHome';
import { faMessages } from '@fortawesome/pro-light-svg-icons/faMessages';
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons/faPaperPlane';
import { faTruckFast } from '@fortawesome/pro-light-svg-icons/faTruckFast';
import {
	MainMenuEntry,
	MainMenuGroup,
	MainNavigation,
	MainNavigationDivider,
	MainNavigationType,
	Tooltip,
	ToolTipPlacement,
	useLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React from 'react';
import { useLayoutStore } from '@ukpostbox/frontend-framework/lib/Providers/Stores/LayoutStore';
import { useAuthorisedUser } from '../../../_Auth/Providers/AuthProvider';
import { MapEventToasts } from '../ServiceAlertManager';
import { UserHelpMenu } from '../UserHelpMenu';
import UserMenu from '../UserMenu';
import { NavigationUnreadBadge } from './NavigationUnreadBadge';

function Navigation(props: MainNavigationType) {
	const { t } = useTranslation();
	const { token } = useAuthorisedUser();
	const { isTiny, isSmall, isUltraWide } = useLayout();

	const sidebarOpen = useLayoutStore((state) => state.sidebarOpen);

	return (
		<MainNavigation
			logo={props.logo}
			extraClass={`branded-nav ${
				process.env.REACT_APP_ENV_LABEL !== 'Production'
					? 'bad-component-highlight staging-component-highlight'
					: ''
			}`}
		>
			<MainMenuGroup>
				<Tooltip
					content={t('navigation.overview')}
					position={ToolTipPlacement.Right}
					disabled={sidebarOpen || isUltraWide}
				>
					<MainMenuEntry title={t('navigation.overview')} url='/' icon={faHome} />
				</Tooltip>

				<Tooltip
					content={t('navigation.mailboxes')}
					position={ToolTipPlacement.Right}
					disabled={sidebarOpen || isUltraWide}
				>
					<MainMenuEntry
						title={t('navigation.mailboxes')}
						url='/mail/inbox'
						icon={faEnvelope}
						addon={token ? <NavigationUnreadBadge name='mail' /> : null}
					/>
				</Tooltip>

				<Tooltip
					content={t('navigation.sendMail')}
					position={ToolTipPlacement.Right}
					disabled={sidebarOpen || isUltraWide}
				>
					<MainMenuEntry title={t('navigation.sendMail')} url='/send-mail/send' icon={faPaperPlane} />
				</Tooltip>

				<Tooltip
					content={t('navigation.messageCentre')}
					position={ToolTipPlacement.Right}
					disabled={sidebarOpen || isUltraWide}
				>
					<MainMenuEntry
						title={t('navigation.messageCentre')}
						url='/message-centre'
						icon={faMessages}
						addon={token ? <NavigationUnreadBadge name='messages' /> : null}
					/>
				</Tooltip>

				{!isTiny && !isSmall && (
					<Tooltip
						content={t('navigation.shippingCalculator')}
						position={ToolTipPlacement.Right}
						disabled={sidebarOpen || isUltraWide}
					>
						<MainMenuEntry
							title={t('navigation.shippingCalculator')}
							url='/shipping-calculator'
							icon={faTruckFast}
						/>
					</Tooltip>
				)}

				{(isTiny || isSmall) && token && <UserMenu />}
			</MainMenuGroup>

			{!isTiny && !isSmall && (
				<MainMenuGroup>
					<UserHelpMenu />

					{token && <MapEventToasts />}

					<MainNavigationDivider />

					{token && <UserMenu />}
				</MainMenuGroup>
			)}
		</MainNavigation>
	);
}

export default Navigation;
